<div class="header-class col-sm-12">
</div>
<div class="col-sm-12" id="incremented-bc-line-list">
    <div *ngIf="form">
        <form [formGroup]="form">
            <div class="table-container">
                <table #table mat-table [dataSource]="matDataSourceBCLigne" formArrayName="bcLines">
                    <caption>Liste des Bcs lignes</caption>
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef> N° Ligne </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.libelle" class="centrer no-padding">
                            {{element.get('code').value}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="libelle">
                        <th mat-header-cell *matHeaderCellDef> Désignation </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.libelle">
                            <div class="with-padding-left">
                                {{element.get('libelle').value}}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="bpList">
                        <th mat-header-cell *matHeaderCellDef> Liste facture </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            <div *ngIf="element.get('bpLines')">
                                <div *ngIf="element.get('bpLines').value">
                                    <ul style="list-style-type:square">
                                        <li *ngFor="let item of element.get('bpLines').value">
                                            <a mat-list-item (click)="goToBp(item.bp.id)"> {{item.bp.code}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="numFactures">
                        <th mat-header-cell *matHeaderCellDef> N° Factures </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            <div *ngIf="element.get('bpLines')">
                                <div *ngIf="element.get('bpLines').value">
                                    <ul style="list-style-type:square" >
                                        <div *ngFor="let item of element.get('bpLines').value">
                                            <li *ngIf="item.bp.numFacture && item.bp.numFacture !== ''" >
                                                <a mat-list-item (click)="goToBp(item.bp.id)" > 
                                                    {{item.bp.numFacture}}
                                                </a>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="tva">
                        <th mat-header-cell *matHeaderCellDef> TVA </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            <div> {{element.get('codeTva').value}} - {{element.get('libelleTva').value }}</div>

                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBC ;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBC; let i = index">
                    </tr>
                </table>
            </div>
            <mat-toolbar>
                <mat-toolbar-row style="padding: 0px; background-color: white;">
                    <mat-paginator class="paginator" style="width: 100%;" [length]="bcLineFormArray.controls.length"
                        [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]">
                    </mat-paginator>
                </mat-toolbar-row>

            </mat-toolbar>
        </form>
    </div>
</div>